export const  SETAUTHTOKEN = 'SETAUTHTOKEN';
export const LOGOUT = 'LOGOUT';